document.addEventListener('DOMContentLoaded', () => {
    const elements = document.querySelectorAll('[data-animate-text="true"]');

    const groups = new Map();
    const singles = [];

    elements.forEach((element) => {
        const groupKey = element.dataset.animateGroup;
        if (groupKey) {
            if (!groups.has(groupKey)) groups.set(groupKey, []);
            groups.get(groupKey).push(element);
        } else {
            singles.push(element);
        }
    });

    const splitIntoWords = (element) => {
        const text = element.textContent.trim();
        const words = text.split(/\s+/);
        const wordElements = [];

        element.innerHTML = '';

        words.forEach((word, index) => {
            const wordSpan = document.createElement('span');
            wordSpan.className = 'relative';

            const innerSpan = document.createElement('span');
            innerSpan.className = 'outline-text-black';
            innerSpan.style.color = '#f1f1f1';
            innerSpan.textContent = word;

            wordSpan.appendChild(innerSpan);
            element.appendChild(wordSpan);
            wordElements.push(innerSpan);

            if (index < words.length - 1) {
                element.appendChild(document.createTextNode(' '));
            }
        });

        return wordElements;
    };

    const computeProgress = (top, height) => {
        const triggerPoint = top + height * 0.2;
        const windowHeight = window.innerHeight;
        const scrollStart = windowHeight * 0.8;
        const scrollEnd = windowHeight * 0.5;
        const scrollRange = scrollStart - scrollEnd;
        return Math.min(Math.max((scrollStart - triggerPoint) / scrollRange, 0), 1);
    };

    const updateWordColors = (wordElements, overallProgress) => {
        const total = wordElements.length;
        wordElements.forEach((word, index) => {
            const wordStartProgress = index / total;
            const wordEndProgress = (index + 1) / total;

            let wordProgress = 0;
            if (overallProgress >= wordEndProgress) {
                wordProgress = 1;
            } else if (overallProgress > wordStartProgress) {
                wordProgress = (overallProgress - wordStartProgress) / (wordEndProgress - wordStartProgress);
            }

            if (wordProgress >= 1) {
                word.style.color = '#000000';
            } else if (wordProgress > 0) {
                const easedProgress = wordProgress * wordProgress * (3 - 2 * wordProgress);
                const grayValue = Math.floor(241 - (easedProgress * 241));
                word.style.color = `rgb(${grayValue}, ${grayValue}, ${grayValue})`;
            } else {
                word.style.color = '#f1f1f1';
            }
        });
    };

    const setupAnimation = (boundsTargets, wordElements) => {
        let rafId = null;

        const update = () => {
            const firstRect = boundsTargets[0].getBoundingClientRect();
            const lastRect = boundsTargets[boundsTargets.length - 1].getBoundingClientRect();
            const top = firstRect.top;
            const height = lastRect.bottom - top;

            const progress = computeProgress(top, height);
            updateWordColors(wordElements, progress);

            rafId = null;
        };

        const scheduleUpdate = () => {
            if (rafId === null) rafId = requestAnimationFrame(update);
        };

        let intersectingCount = 0;
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        intersectingCount += 1;
                    } else {
                        intersectingCount = Math.max(0, intersectingCount - 1);
                    }
                });

                if (intersectingCount > 0) {
                    scheduleUpdate();
                    window.addEventListener('scroll', scheduleUpdate, { passive: true });
                } else {
                    window.removeEventListener('scroll', scheduleUpdate);
                    if (rafId !== null) {
                        cancelAnimationFrame(rafId);
                        rafId = null;
                    }
                }
            },
            { threshold: 0 }
        );

        boundsTargets.forEach((target) => observer.observe(target));
    };

    singles.forEach((element) => {
        const words = splitIntoWords(element);
        setupAnimation([element], words);
    });

    groups.forEach((members) => {
        const allWords = [];
        members.forEach((member) => {
            allWords.push(...splitIntoWords(member));
        });
        setupAnimation(members, allWords);
    });
});
